module.exports = __webpack_public_path__ + "static/media/nlc2.9eeb0b7d.svg";